import { useEffect } from 'react';
import { initializeLanguage } from '../i18n/locale';

export default function usePageMetadata(title, description, path, bodyClass = null) {
  useEffect(() => {
    const previousTitle = document.title;
    const previousLanguage = document.documentElement.lang;
    const descriptionNode = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionNode?.content;
    let canonical = document.querySelector('link[rel="canonical"]');
    const existed = Boolean(canonical);
    const previousCanonical = canonical?.href;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.append(canonical);
    }
    canonical.href = `https://peacetech.app${path}`;
    initializeLanguage(title, description);
    if (bodyClass) document.body.classList.add(bodyClass);
    if (!window.location.hash) window.scrollTo(0, 0);
    return () => {
      if (bodyClass) document.body.classList.remove(bodyClass);
      document.title = previousTitle;
      document.documentElement.lang = previousLanguage;
      if (descriptionNode) descriptionNode.content = previousDescription || '';
      if (existed) canonical.href = previousCanonical;
      else canonical.remove();
    };
  }, [title, description, path, bodyClass]);
}
